import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell, DynamicIconWrapper, Icons } from '@components/common';

import { ICMMavenirVendor, TComparisonDetails } from '@interfaces/cmModule/cmModule';
import { IDataCreatedAt } from '@interfaces/cmModule/dto/configurationComparisonDTO';

import { deltaDescriptionTooltip } from '../../ConsistencyCheck/ConsistencyCheckDetails/constants';

import styles from '../ConfigurationComparison.module.scss';

export const getDynamicColumns = (managedObjects?: string[]) => {
	return (
		managedObjects?.length
			? managedObjects.map((moName) => ({
				header: `${moName} id`,
				accessorKey: `managedObjects_${moName}`,
				cell: ({ row }: CellContext<TComparisonDetails, any>) => {
					const managedObjects = row.original.managedObjects || [];
					const foundObject = managedObjects.find(data => data.moName === moName);

					return <AdaptiveTableCell text={foundObject?.moId} />;
				},
			}))
			: []
	);
};

export const getColumns = ({
	dataSourceCreatedAtFirst,
	dataSourceCreatedAtSecond,
	isMavenirVendor,
}: IDataCreatedAt<string> & ICMMavenirVendor) => {
	return ([
		{
			header: 'Parameter',
			accessorKey: 'paramName',
			cell: ({ getValue }: CellContext<any, any>) => {
				const paramName = getValue();

				return <AdaptiveTableCell text={paramName} />;
			},
		},
		{
			header: 'site id',
			accessorKey: 'siteId',
			isHidden: isMavenirVendor,
			cell: ({ getValue }: CellContext<any, any>) => {
				const siteId = getValue();

				return <AdaptiveTableCell text={siteId} />;
			},
		},
		{
			header: 'node id',
			accessorKey: 'gnbId',
			isHidden: !isMavenirVendor,
			cell: ({ getValue }: CellContext<any, any>) => {
				const gnbId = getValue();

				return <AdaptiveTableCell text={gnbId} />;
			},
		},
		{
			header: 'cnf id',
			accessorKey: 'configId',
			isHidden: !isMavenirVendor,
			cell: ({ getValue }: CellContext<any, any>) => {
				const configId = getValue();

				return <AdaptiveTableCell text={configId} />;
			},
		},
		{
			header: dataSourceCreatedAtFirst,
			accessorKey: 'parameterValueFirst',
			cell: ({ getValue }: CellContext<any, any>) => {
				const parameterValueFirst = getValue();

				return <AdaptiveTableCell text={parameterValueFirst || '-'} />;
			},
		},
		{
			header: dataSourceCreatedAtSecond,
			accessorKey: 'parameterValueSecond',
			cell: ({ getValue }: CellContext<any, any>) => {
				const parameterValueSecond = getValue();

				return <AdaptiveTableCell text={parameterValueSecond || '-'} />;
			},
		},
		{
			header: () => {
				return (
					<span className={styles.deltaHeader}>
						Delta
						<DynamicIconWrapper
							icon={Icons.info}
							tooltipLabel={deltaDescriptionTooltip}
						/>
					</span>
				);
			},
			accessorKey: 'delta',
			enableSorting: false,
			cell: ({ getValue }: CellContext<any, any>) => {
				const delta = getValue();

				return (
					<AdaptiveTableCell
						className={styles.deltaCell}
						text={delta || 'N/A'}
					/>
				);
			},
		},
	]);
};
